import { CxEvent } from '@spartacus/core';

export class Ga4GgCartPageEvent extends CxEvent {
  event?: string;
  visitor_type?: string;
  ecommerce?: {
    currency?: string;
    value?: number;
    items?: {
      item_id?: string;
      item_name?: string;
      discount?: string;
      coupon?: string;
      price?: number;
      quantity?: number;
    }[];
  } | null;
}
